//NOSONAR
import { ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router} from "@angular/router";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {AppStateService} from "src/app/core-module/services/app-state.service";
import {Subject, takeUntil} from "rxjs";
import {ReadDeviceSelectionPopupComponent} from "../read-device-selection-popup/read-device-selection-popup.component";
import {CustomAuthService} from "../../../core-module/services/custom-auth.service";
import {environment} from "../../../../environments/environment";
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
import { MultiOneHttpClient } from "../../../core-module/services/state/multi-one-http-client.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";
import { UserPreferencesStateService } from "../../../core-module/services/state/user-preferences-state.service";
import {
  CONFIGURATION_MODES,
  DEFAULT_CONFIGURATION_MODE,
  STANDARD_CONFIGURATION_MODE,
} from "../../constants/configure-device-modal.constants";
@Component({
  standalone: false,
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, DoCheck {
  redirectUrl = window.location.origin;
  valueChange = {};
  omitValue: string;
  sortCheck: string;
  visibleCheck: string;
  private readonly isOmitCheckedSignal = signal(false);
  private readonly isSortedCheckedSignal = signal(false);
  currentURL;
  private readonly showConfigSignal = signal(false);
  dashboardUrl = "https://signify-portal-oem-tools-acc.trimm.net/dashboard";
  options = [
    { title: "Device Info popup ", value: "omit", name: "omitPopup" },
    { title: "Guidance", value: "guide", name: "guidancePopup" },
    {
      title: "Remember last sorted column",
      value: "sort",
      name: "sortedPopup",
    },
  ];

  private readonly isVisibleCheckedSignal = signal(false);
  private readonly isFilterCheckedSignal = signal(false);
  visibleCheckedValue;
  filterCheckedValue;
  private readonly isMultipleDevicesCheckedSignal = signal(false);

  columnList = [
    "12nc",
    "deviceName",
    "datasheet",
    "applicationArea",
    "pOut",
    "iOutMin",
    "iOutMax",
    "vOutMax",
    "vOutMin",
    "configInterface",
    "dimming",
    "efficiency",
    "operating",
    "isolation",
    "moutning",
    "length",
    "width",
    "height",
  ];
  featurePage;

  preferencesAPI = "config/api/v1/preferences";
  unsubscribe = new Subject<void>();
  lastSortCheckbox;
  configModeCheckedValue;
  storeConfigMode;
  private readonly isconfigurationModeCheckedSignal = signal(false);
  private readonly isFeatureSaveFileCheckedSignal = signal(false);
  private readonly isDCFSaveFileCheckedSignal = signal(false);
  modes = [...CONFIGURATION_MODES];
  firstMode: LegacyAny = DEFAULT_CONFIGURATION_MODE;
  private readonly isRemovedSignal = signal(true);
  isModeChecked: LegacyAny;
  readerBaseUrl: LegacyAny[];
  readerListUrl = "/peripheral/v1/types";
  readerData;
  listReader = [];
  readerType = "SimpleSet";
  readerConnected: boolean = false;
  readerInfo = {
    readerType: "SimpleSet",
    message: "Not connected",
    readerConnected: false,
  };
  modalRefUnSubscribe: NgbModalRef;
  isLoggedin: boolean = false;
  pathVal: string;

  @ViewChild("logoutMenu", { static: false }) logoutmenu: ElementRef;
  url: string;

  private readonly isLogoutMenuOpenSignal = signal(false);
  private readonly isPreferencesMenuOpenSignal = signal(false);
  private readonly isSecondaryMenuOpenSignal = signal(false);

  get isLogoutMenuOpen(): boolean { return this.isLogoutMenuOpenSignal(); }
  get isPreferencesMenuOpen(): boolean { return this.isPreferencesMenuOpenSignal(); }
  get isSecondaryMenuOpen(): boolean { return this.isSecondaryMenuOpenSignal(); }

  get isOmitChecked(): boolean { return this.isOmitCheckedSignal(); }
  set isOmitChecked(value: boolean) { this.isOmitCheckedSignal.set(!!value); }

  get isSortedChecked(): boolean { return this.isSortedCheckedSignal(); }
  set isSortedChecked(value: boolean) { this.isSortedCheckedSignal.set(!!value); }

  get showConfig(): boolean { return this.showConfigSignal(); }
  set showConfig(value: boolean) { this.showConfigSignal.set(value); }

  get isVisibleChecked(): boolean { return this.isVisibleCheckedSignal(); }
  set isVisibleChecked(value: boolean) { this.isVisibleCheckedSignal.set(!!value); }

  get isFilterChecked(): boolean { return this.isFilterCheckedSignal(); }
  set isFilterChecked(value: boolean) { this.isFilterCheckedSignal.set(!!value); }

  get isMultipleDevicesChecked(): boolean { return this.isMultipleDevicesCheckedSignal(); }
  set isMultipleDevicesChecked(value: boolean) { this.isMultipleDevicesCheckedSignal.set(!!value); }

  get isconfigurationModeChecked(): boolean { return this.isconfigurationModeCheckedSignal(); }
  set isconfigurationModeChecked(value: boolean) { this.isconfigurationModeCheckedSignal.set(!!value); }

  get isFeatureSaveFileChecked(): boolean { return this.isFeatureSaveFileCheckedSignal(); }
  set isFeatureSaveFileChecked(value: boolean) { this.isFeatureSaveFileCheckedSignal.set(!!value); }

  get isDCFSaveFileChecked(): boolean { return this.isDCFSaveFileCheckedSignal(); }
  set isDCFSaveFileChecked(value: boolean) { this.isDCFSaveFileCheckedSignal.set(!!value); }

  get isRemoved(): boolean { return this.isRemovedSignal(); }
  set isRemoved(value: boolean) { this.isRemovedSignal.set(value); }

  constructor(
    
    private readonly authSrv: CustomAuthService,
    public router: Router,
    private readonly modalService: NgbModal,
    private readonly cdRef: ChangeDetectorRef,
    private readonly appState: AppStateService,
    private readonly utils: FeatureUtilsService,
    private readonly uiSignals: UiSignalsStateService,
    private readonly httpClient: MultiOneHttpClient,
    private readonly availFeat: AvailableFeaturesStateService,
    private readonly userPrefs: UserPreferencesStateService
  ) {}

  subscription;
  ngOnInit() {
    this.pathVal = this.utils.getImageUrl(window.location.hostname);

    // Initialize mode state immediately to ensure consistent state across app
    this.appState.setModes(this.firstMode);
    this.uiSignals.sendModes(this.firstMode);

    const onLogin = () => {

      this.url = environment.multiOneAPIUrl
            this.subscription = this.httpClient
              .apiCall("get", this.url + this.preferencesAPI)
              .subscribe((response) => {
                const configModeObj = {};
                const saveOmitOption = {};
                const sortObj = {};
                const filterObj = {};
                const storeColumn = {};
                const storeSaveFeatureFile = {};
                const storeDCFfile = {};
                if (response !== null) {
                  // Store columns data AND check flag together
                  if (response["storeColumn"]) {
                    storeColumn["storeColumnsData"] = response["storeColumn"]["storeColumnsData"];
                    storeColumn["storeColumnsCheck"] = response["storeColumn"]["storeColumnsCheck"] || false;
                  }

                  // Store filter data AND check flag together
                  if (response["storeFilter"]) {
                    filterObj["storeFilterData"] = response["storeFilter"]["storeFilterData"];
                    filterObj["storeFilterCheck"] = response["storeFilter"]["storeFilterCheck"] || false;
                  }

                  // Store sorting data AND check flag together
                  if (response["lastSorting"]) {
                    sortObj["storeLastSortedColumn"] = response["lastSorting"]["storeLastSortedColumn"];
                    sortObj["storeLastColumnCheck"] = response["lastSorting"]["storeLastColumnCheck"] || false;
                  }

                  // Store omit option data AND check flag together
                  if (response["storeOmitOption"]) {
                    saveOmitOption["storeDevicePopupValue"] = response["storeOmitOption"]["storeDevicePopupValue"];
                    saveOmitOption["storeDevicePopupCheck"] = response["storeOmitOption"]["storeDevicePopupCheck"] || false;
                  }

                  // Store config mode data AND check flag together
                  if (response["storeConfigMode"]) {
                    configModeObj["storeConfigModeData"] = response["storeConfigMode"]["storeConfigModeData"];
                    configModeObj["storeConfigModeCheck"] = response["storeConfigMode"]["storeConfigModeCheck"] || false;
                  }

                  this.isMultipleDevicesChecked = response["storeConcecutiveMultiple"] ? true : false;
                  this.appState.setStoreConcecutiveMultiple(this.isMultipleDevicesChecked);

                  // Now save everything to appState
                  if (configModeObj["storeConfigModeData"]) {
                    this.isModeChecked = configModeObj["storeConfigModeCheck"];
                    this.firstMode = configModeObj["storeConfigModeData"];
                    this.appState.setStoreConfigMode(configModeObj);
                  } else {
                    const modes = this.appState.getModes();
                    if (modes) {
                      this.firstMode = modes;
                    } else {
                      this.firstMode = DEFAULT_CONFIGURATION_MODE;
                    }
                    configModeObj["storeConfigModeData"] = this.firstMode;
                    configModeObj["storeConfigModeCheck"] = false;
                    this.appState.setStoreConfigMode(configModeObj);
                  }

                  if (saveOmitOption["storeDevicePopupValue"]) {
                    this.isOmitChecked = saveOmitOption["storeDevicePopupCheck"];
                    this.appState.setStoreOmitOption(saveOmitOption);
                  }

                  if (sortObj["storeLastSortedColumn"]) {
                    this.isSortedChecked = sortObj["storeLastColumnCheck"];
                    this.appState.setLastSorting(sortObj);
                  }

                  if (filterObj["storeFilterData"]) {
                    this.isFilterChecked = filterObj["storeFilterCheck"];
                    this.appState.setStoreFilter(filterObj);
                  }

                  if (storeColumn["storeColumnsData"]) {
                    this.isVisibleChecked = storeColumn["storeColumnsCheck"];
                    this.appState.setStoreColumn(storeColumn);
                  }

                  if (response && response["storeSaveFeatureFile"]) {
                    this.isFeatureSaveFileChecked =
                      response["storeSaveFeatureFile"][
                        "storeSaveFeatureFileCheck"
                      ];
                    this.appState.setStoreSaveFeatureFile(response["storeSaveFeatureFile"]);
                  } else {
                    this.isFeatureSaveFileChecked = false;
                    storeSaveFeatureFile["storeSaveFeatureFileCheck"] = false;
                    storeSaveFeatureFile["storeSaveFeatureFileCheckValue"] =
                      "savefeaturefile";
                    this.appState.setStoreSaveFeatureFile(storeSaveFeatureFile);
                  }

                  if (response && response["storeDCFFile"]) {
                    this.isDCFSaveFileChecked =
                      response["storeDCFFile"]["storeDCFFileCheck"];

                    this.appState.setStoreDCFFile(response["storeDCFFile"]);
                  } else {
                    this.isDCFSaveFileChecked = false;
                    storeDCFfile["storeDCFFileCheck"] = false;
                    storeDCFfile["storeDCFFileCheckValue"] = "dcffile";

                    this.appState.setStoreDCFFile(storeDCFfile);
                  }

                  // var newmode;
                  // if(response['storeConfigMode']['storeConfigModeData'] === 'standard'){
                  //   newmode = 'Advanced';
                  //   this.firstMode = 'Advanced';
                  // } else if(response['storeConfigMode']['storeConfigModeData'] === 'quickConfig') {
                  //   newmode = 'Standard';
                  //   this.firstMode = 'Standard';
                  // }
                  this.uiSignals.sendModes(this.firstMode);
                } else {
                  this.isFeatureSaveFileChecked = false;
                  this.isDCFSaveFileChecked = false;
                  this.isMultipleDevicesChecked = false;
                  configModeObj["storeConfigMode"] = false;
                  configModeObj["storeConfigModeData"] = "Advanced";

                  storeColumn["storeColumnsData"] = this.columnList;
                  storeColumn["storeColumnsCheck"] = false;

                  filterObj["storeFilterData"] = [];
                  filterObj["storeFilterCheck"] = false;

                  sortObj["storeLastSortedColumn"] = ["12nc"];
                  sortObj["storeLastColumnCheck"] = false;

                  saveOmitOption["storeDevicePopupCheck"] = false;

                  storeSaveFeatureFile["storeSaveFeatureFileCheck"] = false;
                  storeSaveFeatureFile["storeSaveFeatureFileCheckValue"] =
                    "savefeaturefile";

                  storeDCFfile["storeDCFFileCheck"] = false;
                  storeDCFfile["storeDCFFileCheckValue"] = "dcffile";

                  this.appState.setStoreSaveFeatureFile(storeSaveFeatureFile);
                  this.appState.setStoreDCFFile(storeDCFfile);

                  this.appState.setStoreConfigMode(configModeObj);
                  this.appState.setStoreColumn(storeColumn);
                  this.appState.setStoreFilter(filterObj);
                  this.appState.setStoreOmitOption(saveOmitOption);
                  this.appState.setLastSorting(sortObj);
                  this.appState.setStoreConcecutiveMultiple(this.isMultipleDevicesChecked);
                  this.httpClient.postCallForUserPreferences();
                }
              });
        //   }
        // });
    };
    this.authSrv.onLogin.pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      if (res) onLogin();
    });

    this.authSrv.onLogout.pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      if (res && this.logoutmenu) {
        this.logoutmenu.nativeElement.classList.remove("show");
      }
      if (res) {
        this.isLogoutMenuOpenSignal.set(false);
        this.isPreferencesMenuOpenSignal.set(false);
        this.isSecondaryMenuOpenSignal.set(false);
      }
    });
    if (this.authSrv.isUserLoggedIn()) {
      onLogin();
    }

    this.availFeat.checkConfigData.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data === "featureConfiguration") {
        this.currentURL = window.location.href;
        if (this.currentURL.includes("featureLanding")) {
          this.showConfig = true;
        }
      } else {
        this.showConfig = false;
      }
    });

    this.userPrefs.getFeaturePage.pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
      if (resp === "Isvalid") {
        this.featurePage = true;
      } else {
        this.featurePage = false;
      }
    });
    this.uiSignals.getSelect.pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
      if (resp === "valid") {
        this.isRemoved = true;
        this.cdRef.detectChanges();
      } else if (resp === "invalid") {
        this.isRemoved = false;
        this.cdRef.detectChanges();
      }
    });
    const Url = window.location.href;
    if (Url.includes("home") || Url.includes("deviceList?response=")) {
      this.uiSignals.removeModes("invalid");
    } else {
      this.uiSignals.removeModes("valid");
    }

    this.uiSignals.getmodes.pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
      // var mode = JSON.parse(localStorage.getItem('modes'));
      // setTimeout(() => {
      if (resp === "Standard" || resp === "quickConfig") {
        this.firstMode = STANDARD_CONFIGURATION_MODE;
        this.appState.setModes(this.firstMode);
      } else if (resp === "standard" || resp === "Advanced") {
        this.firstMode = DEFAULT_CONFIGURATION_MODE;
        this.appState.setModes(this.firstMode);
      }
      const obj = {};
      if (this.configModeCheckedValue || this.isModeChecked) {
        let newmode;
        if (resp === "Standard" || resp === "quickConfig") {
          newmode = "Standard";
        } else if (resp === "Advanced" || resp === "standard") {
          newmode = "Advanced";
        }
        if (this.isconfigurationModeChecked) {
          obj["storeConfigModeData"] = newmode;
          obj["storeConfigModeCheck"] = true;
          this.appState.setStoreConfigMode(obj);
        }
      }
      // }, 500);
    });

    // React to reader-info changes reactively so the header updates without
    // waiting for the next user interaction (required for OnPush components).
    this.appState.getState().pipe(takeUntil(this.unsubscribe)).subscribe((state) => {
      this.syncReaderInfoFromState(state.detectedReaderInfo, state.readerInfo);
      this.cdRef.markForCheck();
    });
  }

  private syncReaderInfoFromState(detectedReaderInfo: LegacyAny, readerInfoState: LegacyAny): void {
    if (detectedReaderInfo && detectedReaderInfo !== "undefined") {
      const nextReaderInfo = {
        // Clear reader type when disconnected or no selected reader
        readerType: (detectedReaderInfo.selectedReader && detectedReaderInfo.readerConnected) 
          ? detectedReaderInfo.readerType 
          : "SimpleSet",
        message: "Not connected",
        readerConnected: !!detectedReaderInfo.readerConnected,
      };
      // Only show reader details if both selectedReader exists AND connected
      if (detectedReaderInfo.selectedReader && detectedReaderInfo.readerConnected) {
        nextReaderInfo.message =
          detectedReaderInfo.selectedReader.peripheralType +
          "-" +
          detectedReaderInfo.selectedReader.peripheralId;
      }
      this.readerInfo = nextReaderInfo;
    }
    if (!readerInfoState) {
      this.readerInfo = {
        readerType: "SimpleSet",
        message: "Not connected",
        readerConnected: false,
      };
    }
  }

  ngDoCheck() {
    // Track login state changes to trigger change detection
    const currentLoginState = this.authSrv.isUserLoggedIn();
    if (currentLoginState !== this.isLoggedin) {
      this.isLoggedin = currentLoginState;
      this.cdRef.detectChanges();
    }

    const storedOmitOption = this.appState.getStoreOmitOption();
    if (storedOmitOption) {
      this.omitValue = storedOmitOption;
      this.isOmitChecked = this.omitValue["storeDevicePopupCheck"];
    } else {
      this.isOmitChecked = null;
    }

    if (
      this.appState.getDetectedReaderInfo() &&
      this.appState.getDetectedReaderInfo() != "undefined"
    ) {
      const reader = this.appState.getDetectedReaderInfo();
      const hostname = window.location.hostname;
      //const isLocalOrStaging = hostname.includes("www.multione.signify.com") || hostname.includes("staging");  // remove this once box configuration is enabled

      // Clear reader type when disconnected or no selected reader
      this.readerInfo.readerType = (reader.selectedReader && reader.readerConnected) 
        ? reader.readerType 
        : "SimpleSet";
      // if (
      //   reader.selectedReader &&
      //   reader.selectedReader.peripheralType === "LCN9640"
      //  // &&isLocalOrStaging
      // ) {
      //   this.readerInfo.message = "Not Connected";
      //   this.readerInfo.readerConnected = false;
      // } else  // uncomment to disable box configuration on staging

        // Only show reader details if both selectedReader exists AND connected
        if (reader.selectedReader && reader.readerConnected) {
        this.readerInfo.message =
          reader.selectedReader.peripheralType +
          "-" +
          reader.selectedReader.peripheralId;
        this.readerInfo.readerConnected = reader.readerConnected;
      } else {
        this.readerInfo.message = "Not connected";
        this.readerInfo.readerConnected = reader.readerConnected;
      }
    }
    if (!this.appState.getReaderInfo()) {
      this.readerInfo = {
        readerType: "SimpleSet",
        message: "Not connected",
        readerConnected: false,
      };
    }
    const storedConfigMode = this.appState.getStoreConfigMode();
    if (storedConfigMode) {
      this.storeConfigMode = storedConfigMode;
      this.isconfigurationModeChecked =
        this.storeConfigMode["storeConfigModeCheck"];
    } else {
      this.isconfigurationModeChecked = null;
    }

    const sortColData = this.appState.getSortCol();
    if (sortColData) {
      this.sortCheck = sortColData;
      this.isSortedChecked = this.sortCheck["boolVal"];
    } else {
      this.isSortedChecked = null;
    }

    const storedColumn = this.appState.getStoreColumn();
    if (storedColumn) {
      this.visibleCheck = storedColumn;
      this.isVisibleChecked = this.visibleCheck["storeColumnsCheck"];
    } else {
      this.isVisibleChecked = null;
      this.appState.removeStoreColumn();
    }

    const lastSortingData = this.appState.getLastSorting();
    if (lastSortingData) {
      const visibleCheck = lastSortingData;
      this.isSortedChecked = visibleCheck["storeLastColumnCheck"];
    } else {
      this.isSortedChecked = null;
      this.appState.removeStoreLastColumnCheck();
    }

    const storedFilter = this.appState.getStoreFilter();
    if (storedFilter) {
      this.visibleCheck = storedFilter;
      this.isFilterChecked = this.visibleCheck["storeFilterCheck"];
    } else {
      this.isFilterChecked = null;
      this.appState.removeStoreFilter();
    }
  }

  login() {
    this.authSrv.login();
  }

  get isLoggedIn() {
    return this.authSrv.isUserLoggedIn();
  }

  getUserName() {
    return this.authSrv.getUserName();
  }

  home() {
    this.appState.removeDynaDimmerSchema();
    this.appState.removeDynaScenes();
    this.appState.setConfigurationData(null);
    this.appState.setCompareFirmwareNoLatest(null);
    this.uiSignals.removeModes("invalid");
    this.uiSignals.configModeRefresh("pass");
    const url = window.location.href;
    const modes = this.appState.getModes();
    const setmode = this.appState.getSetmode();
    const fileCreated = this.appState.getFeatureFileCReation();

    this.appState.setExportedFeatureFile(false);
    this.appState.removeFeatureFileCReation();
    this.appState.removeQuickConfiguration();
    this.appState.setConfigId(null);
    this.router.navigate(["/home"]);
  }
  userPref(e) {
    e.stopPropagation();
  }

  toggleLogoutMenu(event: Event): void {
    event.stopPropagation();
    const next = !this.isLogoutMenuOpenSignal();
    this.isLogoutMenuOpenSignal.set(next);
    this.isSecondaryMenuOpenSignal.set(false);
    if (!next) {
      this.isPreferencesMenuOpenSignal.set(false);
    }
  }

  togglePreferencesMenu(event: Event): void {
    event.stopPropagation();
    this.isPreferencesMenuOpenSignal.update((v) => !v);
  }

  toggleSecondaryMenu(event: Event): void {
    event.stopPropagation();
    const next = !this.isSecondaryMenuOpenSignal();
    this.isSecondaryMenuOpenSignal.set(next);
    this.isLogoutMenuOpenSignal.set(false);
    this.isPreferencesMenuOpenSignal.set(false);
  }

  @HostListener("document:click")
  closeMenusOnOutsideClick(): void {
    if (
      this.isLogoutMenuOpenSignal() ||
      this.isPreferencesMenuOpenSignal() ||
      this.isSecondaryMenuOpenSignal()
    ) {
      this.isLogoutMenuOpenSignal.set(false);
      this.isPreferencesMenuOpenSignal.set(false);
      this.isSecondaryMenuOpenSignal.set(false);
    }
  }

  logout() {
    this.authSrv.handleTokenExpiry(true);
  }

  getDevieList() {
    this.listReader = this.readerData;
    const modalRef = this.modalService.open(ReadDeviceSelectionPopupComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: "select-device-modal-comp",
      centered: true,
      size: "lg",
    });
    this.modalRefUnSubscribe = modalRef;
    modalRef.componentInstance.readerName = this.listReader;
    modalRef.componentInstance.clickEvent = true;
    modalRef.componentInstance.componentFrom = "Header";
  }

  getDeviceReader() {
    return this.httpClient.getServerStatus(this.readerBaseUrl);
  }

  getReaderList() {
    return this.httpClient.apiCall(
      "get",
      this.readerBaseUrl + this.readerListUrl
    );
  }

  sortedCol(event, checkboxtype) {
    this.lastSortCheckbox = event;

    // Read from appState instead of making GET call
    const sortObj = this.appState.getLastSorting() || {};
    if (this.lastSortCheckbox) {
      sortObj["storeLastColumnCheck"] = this.lastSortCheckbox;
      this.appState.setLastSorting(sortObj);
      this.httpClient.postCallForUserPreferences();
    } else {
      sortObj["storeLastColumnCheck"] = this.lastSortCheckbox;
      this.userPrefs.sendUncheckSort("uncheck");
      this.appState.setLastSorting(sortObj);
      this.httpClient.postCallForUserPreferences();
    }
  }

  visibleColumns(event, visibleColumns) {
    this.visibleCheckedValue = event;

    // Read from appState instead of making GET call
    const obj = this.appState.getStoreColumn() || {};
    obj["storeColumnsCheck"] = this.visibleCheckedValue;
    this.appState.setStoreColumn(obj);
    this.httpClient.postCallForUserPreferences();
  }

  onPreChange(event, checkboxtype) {
    this.valueChange["storeDevicePopupCheck"] = event;
    this.valueChange["storeDevicePopupValue"] = checkboxtype;

    this.appState.setStoreOmitOption(this.valueChange);
    this.httpClient.postCallForUserPreferences();
  }

  onChangeSaveFeatureFile(event, checkboxtype) {
    const saveFeatureFile = {};

    saveFeatureFile["storeSaveFeatureFileCheck"] = event;
    saveFeatureFile["storeSaveFeatureFileCheckValue"] = checkboxtype;

    this.appState.setStoreSaveFeatureFile(saveFeatureFile);
    this.httpClient.postCallForUserPreferences();
  }

  onChangeDCFFile(event, checkboxtype) {
    const saveDCFFile = {};

    saveDCFFile["storeDCFFileCheck"] = event;
    saveDCFFile["storeDCFFileCheckValue"] = checkboxtype;

    this.appState.setStoreDCFFile(saveDCFFile);
    this.httpClient.postCallForUserPreferences();
  }

  configurationModeChange(event, configurationMode) {
    this.configModeCheckedValue = event;

    // Read from appState instead of making GET call
    const obj = this.appState.getStoreConfigMode() || {};
    if (this.configModeCheckedValue) {
      const standardConfig = this.appState.getModes();
      obj["storeConfigModeData"] = standardConfig;
      obj["storeConfigModeCheck"] = this.configModeCheckedValue;
      this.appState.setStoreConfigMode(obj);
      this.httpClient.postCallForUserPreferences();
    } else {
      obj["storeConfigModeCheck"] = this.configModeCheckedValue;
      this.appState.setStoreConfigMode(obj);
      this.httpClient.postCallForUserPreferences();
    }
  }
  webShopLogin() {
    this.dashboardUrl = "https://" + "www.emea.oemwebshop.signify.com/";
    window.open(this.dashboardUrl, "_blank");
  }
  designInLogin() {
    this.dashboardUrl =
      "https://" + "www.easydesignintool.signify.com/#/advanced";
    window.open(this.dashboardUrl, "_blank");
  }
  oEMLogin() {
    if(window.location.hostname.includes('localhost') || window.location.hostname.includes('dev') || window.location.hostname.includes('tst'))
      this.dashboardUrl=`https://tst.mylighting.signify.com/#/myli/home`
    else if(window.location.hostname.includes('staging') || window.location.hostname.includes("www.multione.signify.com"))
      this.dashboardUrl=`https://www.mylighting.signify.com/#/myli/home`
    window.open(this.dashboardUrl, "_blank");
  }

  fileConverterLogin() {
    const hostname = window.location.hostname;
    let fileConverterUrl: string;
    if (hostname.includes('localhost') || hostname.includes('dev')) {
      fileConverterUrl = `https://dev.fileconverter.multione.signify.com/`;
    } else if (hostname.includes('tst')) {
      fileConverterUrl = `https://tst.fileconverter.multione.signify.com/`;
    } else if (hostname.includes('staging')) {
      fileConverterUrl = `https://staging.fileconverter.multione.signify.com/`;
    } else {
      fileConverterUrl = `https://www.fileconverter.multione.signify.com/`;
    }
    window.open(fileConverterUrl, '_blank');
  }

  visiblFilter(event, visibleFilter) {
    this.filterCheckedValue = event;

    // Read from appState instead of making GET call
    const obj = this.appState.getStoreFilter() || {};
    obj["storeFilterCheck"] = this.filterCheckedValue;
    this.appState.setStoreFilter(obj);
    this.httpClient.postCallForUserPreferences();
  }

  multipleDevices(event, visibleFilter) {
    this.isMultipleDevicesChecked = event;
    this.appState.setStoreConcecutiveMultiple(this.isMultipleDevicesChecked);
    this.httpClient.postCallForUserPreferences();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    //  this.uiSignals.sendModes('')
    if (this.modalService && typeof this.modalService.dismissAll === 'function') {
      this.modalService.dismissAll();
    }

    if (this.modalRefUnSubscribe) {
      this.modalRefUnSubscribe.close();
    }
  }
  changeMode(modes) {
    this.appState.setModes(modes);
    this.uiSignals.sendModes(modes);
  }

  goBack() {

  }
}

